var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-block",class:[_vm.themeClass, _vm.textBlockClasses],attrs:{"data-cy":_vm.dataCy}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }